export const EMAIL = '^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$';
export const BENUTZERNAME = '.{6,100}';
export const PLZ = '^\\d{5}(?:\\d{2})?$';
export const TELEFON = '^(\\+49|0)[1-9][0-9]{0,12}$';
export const STEUERNUMMER = '\\d{10,11}';
